import {reduxForm, Field} from 'redux-form';
import React from 'react';
import {renderField} from '../../../common/FormsControls.jsx';
import {required} from '../../../../../_utils/validators';
import contactValidator from '../contact-validator';

class ContactForm extends React.Component {
  validate = (value, allValues) => {
    return contactValidator(value, allValues['type']);
  };

  render() {
    const {anyTouched, invalid, submitting, handleSubmit} = this.props;
    return <form onSubmit={handleSubmit} className={anyTouched ? 'was-validate' : ''}>
      <div className="d-flex flex-row control-group">
        <div className="flex-column pr-2">
          <Field name="type"
                 component={renderField}
                 element="select"
                 validate={[required]}>
            <option/>
            <optgroup label="Основные">
              <option value="email">E-mail</option>
              <option value="website">Веб-сайт</option>
              <option value="phone">Телефон</option>
              <option value="skype">Скайп</option>
            </optgroup>
            <optgroup label="Социальные сети">
              <option value="vk">В контакте</option>
              <option value="facebook">Facebook</option>
              <option value="odnoklassniki">Одноклассники</option>
              <option value="twitter">Twitter</option>
              <option value="youtube">Youtube</option>
              <option value="instagram">Инстаграм</option>
            </optgroup>
          </Field>
        </div>
        <div className="flex-column flex-grow-1 pr-2">
          <Field placeholder={gettext('Учётная запись')}
                 component={renderField}
                 name='account'
                 validate={[this.validate]} />
        </div>
        <div className="flex-column">
          <button className="btn btn-dark" title={gettext('Сохранить контакт')} disabled={submitting || invalid}>
            <i className="icon icon-plus"></i>
          </button>
        </div>
      </div>
    </form>
  }
}

export default reduxForm({form: 'contactForm'})(ContactForm)